module.exports = __webpack_public_path__ + "media/stylesheets/images/logo_mattrz-c9595baa880bb1fe8b667c6a7db683c8.svg";